import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EndpointNameEditProps {
  onSubmit: () => void;
  endpointNode: string;
  endpointName: string;
}
export const EndpointNameEdit = ({
  onSubmit,
  endpointNode,
  endpointName,
}: EndpointNameEditProps) => {
  const api = useApi();
  const [name, setName] = React.useState(endpointName);

  const epNamePost = useMutation(api.setEndpointNameApiV1SetEndpointNamePost, {
    onSuccess() {
      toast.success('Updated Endpoint name successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    epNamePost.mutate({
      ep_id: endpointNode,
      ep_name: name,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        fullWidth
        id="endpoint-name"
        label="Endpoint Name"
        variant="outlined"
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save Name
        </Button>
      </Box>
    </Box>
  );
};
